module.exports = {"id":"209780","name":"Siebe Schrijvers","rating":"72","photo":"./data/images/photos/4/209780.png","club":{"name":"KRC Genk","logo":"./data/images/clubs/KRCGenk.png"},"positions":["MOC","ATT","MC","MG"],"photoFolderIndex":4}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/SiebeSchrijvers0.json
// module id = 3950
// module chunks = 0